<h2 mat-dialog-title>{{data?.title ? data.title : ''}}</h2>
<mat-dialog-content>
  <ng-container *ngComponentOutlet="data.component"></ng-container>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button color="warn" [mat-dialog-close]="true">Close</button>
</mat-dialog-actions>